.tabs {
  display: flex;
  align-items: stretch;
  min-width: 0;
  overflow-x: auto;
}

.tabs button {
  min-height: 2.75rem;
  border: 0;
  background: transparent;
  color: var(--ink-secondary);
  font: inherit;
  white-space: nowrap;
  cursor: pointer;
}

.tabs button:focus-visible,
.iconButton:focus-visible,
.menuItem:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-offset);
}

.tabsLine {
  border-bottom: 1px solid var(--line-strong);
}

.tabsLine button {
  flex: 1;
  padding: var(--space-3) var(--space-4);
  border-bottom: 2px solid transparent;
}

.tabsLine button[aria-selected='true'] {
  border-bottom-color: var(--accent);
  color: var(--accent-strong);
}

.tabsCompact {
  gap: var(--space-2);
}

.tabsCompact button {
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--line-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-inset);
}

.tabsCompact button[aria-selected='true'] {
  border-color: var(--accent);
  background: var(--accent-wash);
  color: var(--accent-strong);
  font-weight: 600;
}

.menuRoot {
  position: relative;
  display: inline-flex;
}

.iconButton {
  display: inline-grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-md);
  background: var(--surface-inset);
  color: var(--ink-secondary);
  cursor: pointer;
}

.iconButton:hover,
.iconButton[aria-expanded='true'] {
  border-color: var(--accent-dim);
  background: var(--surface-hover);
  color: var(--ink-primary);
}

.iconButton svg {
  width: var(--space-5);
  height: var(--space-5);
  fill: currentcolor;
}

.menu {
  position: absolute;
  z-index: 10;
  top: calc(100% + var(--space-2));
  display: grid;
  min-width: var(--measure-field-narrow);
  padding: var(--space-1);
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-md);
  background: var(--surface-overlay);
  box-shadow: var(--shadow-overlay);
}

.menuStart {
  left: 0;
}

.menuEnd {
  right: 0;
}

.menuItem {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--ink-primary);
  font: inherit;
  font-size: var(--text-sm);
  text-align: left;
  cursor: pointer;
}

.menuItem:hover,
.menuItem:focus-visible {
  background: var(--surface-hover);
}

.menuItemDanger {
  color: var(--negative);
}
